import clsx from 'clsx'
import { WidgetHeader } from 'components/WidgetHeader'
import { ChatDetail } from 'components/chats/ChatDetail'
import { ChatBottomBar } from 'components/ChatBottomBar'
import { ChatTextInput } from 'components/ChatTextInput'
import { useSelector } from 'react-redux'
import { selectChatId } from 'store/messages'
import { ChatsList } from 'components/chats/ChatsList'
import { useGetBotMode } from 'hooks/useGetBotMode'
import { ModalOutlet } from 'providers/ModalProvider'
import { PortalToastContainer } from 'components/ui/PortalToastContainer'
import { CookieConsent } from 'components/cookie/CookieConsent'

export const WidgetContent = () => {
  const chatId = useSelector(selectChatId)
  const { isAppMode } = useGetBotMode()

  if (isAppMode) {
    return (
      <div
        className={clsx(
          'tw-xs:w-full tw-fixed tw-bottom-1 tw-flex tw-h-[100%] tw-w-[100vw] tw-flex-col tw-rounded-[16px] tw-mt-3 tw-font-figtree',
        )}
        key="widget"
      >
        <div
          className="tw-relative tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden tw-rounded-[16px]"
          style={{
            background: 'var(--surface-glass)',
            border: '1px solid var(--border-default)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <WidgetHeader />
          {!chatId && <ChatsList />}
          {!!chatId && (
            <>
              <ChatDetail />
              <ChatBottomBar>
                <ChatTextInput />
              </ChatBottomBar>
            </>
          )}
          <PortalToastContainer topOffset={80} />
          <CookieConsent surface="widget" />
          <ModalOutlet />
        </div>
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'animate-slide-up-widget tw-ring-black-5 tw-xs:right-0 tw-xs:w-full tw-fixed tw-bottom-5 tw-right-5 tw-z-50 tw-flex tw-w-[400px] tw-max-w-[90vw] tw-h-[calc(99dvh-96px)] tw-max-h-[40rem] tw-flex-col tw-rounded-[16px] tw-font-figtree',
      )}
    >
      <div
        className="tw-relative tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden tw-rounded-[16px]"
        style={{
          background: 'var(--surface-glass)',
          border: '1px solid var(--border-default)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <WidgetHeader />
        {!chatId && <ChatsList />}
        {!!chatId && (
          <>
            <ChatDetail />
            <ChatBottomBar>
              <ChatTextInput />
            </ChatBottomBar>
          </>
        )}
        <PortalToastContainer topOffset={80} />
        <CookieConsent surface="widget" />
        <ModalOutlet />
      </div>
    </div>
  )
}
